import React from "react";
import ReactDOM from "react-dom";
import { get } from "lodash";
import { createBrowserHistory } from "history";
import { Router, Route } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns"
import { MuiPickersUtilsProvider } from "@material-ui/pickers"
import configureStore from "./config/configureStore";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import { CaptureConsole } from "@sentry/integrations";
import MainRouter from "views/mainrouter";
import {clearCookiesAndLocalStorage} from "utils/clearCookies";
import { syncORMWithStore } from './orm'
import "assets/css/styles.css?v=1.9.0";

if (get(window, ["LOCAL_SETTINGS", "SENTRY_DSN"])) {
  Sentry.init({
    dsn: window.LOCAL_SETTINGS.SENTRY_DSN,
    release: "bossfotos_photographer",
    integrations: [
      new Integrations.BrowserTracing(),
      new CaptureConsole({
        levels: ["error"],
      }),
    ],
    tracesSampleRate: 1.0,
  });
}

clearCookiesAndLocalStorage()
const hist = createBrowserHistory()
export const store = configureStore()
syncORMWithStore(store)
 

ReactDOM.render(
    <Provider store={store}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Router history={hist}>
          <Route path="/" component={MainRouter} />
        </Router>
      </MuiPickersUtilsProvider>
    </Provider>,
    document.getElementById("root")
);
